import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-terms-of-use-en',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './terms-of-use-en.component.html',
  styleUrls: ['./terms-of-use.component.scss'],
})
export class TermsOfUseEnComponent {
  @Input() effectiveDate!: string;
  @Input() version!: string;
  @Input() supportEmail!: string;
  @Input() websiteUrl!: string;
  @Input() termsUrl!: string;
  @Input() rssFeedUrl!: string;
}
